import { render, staticRenderFns } from "./up-record.vue?vue&type=template&id=7e6f3b71&"
import script from "./up-record.vue?vue&type=script&lang=js&"
export * from "./up-record.vue?vue&type=script&lang=js&"
import style0 from "./up-record.vue?vue&type=style&index=0&id=7e6f3b71&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports